var View = require('views/view')
var app = require('application')

Handlebars.registerPartial('aside', require('views/templates/aside'))
Handlebars.registerPartial('top', require('views/templates/top'))
Handlebars.registerPartial('footer', require('views/templates/footer'))
Handlebars.registerPartial('top-cart', require('views/templates/top-cart'))
Handlebars.registerPartial('top-cart-resume', require('views/templates/top-cart-resume'))

module.exports = View.extend({
  template: require('views/templates/home'),
  rendered: false,
  getParams (e) {
    if (this.session) {
      return this.session.custom.param
    }
  },
  events: {
    'click #logout-btn': 'logout',
    'click .aside-add-new-conseil': 'newConseil',
    'click .top-btn-remove-cart': 'removeFromCart',
    'click #global-search-process': 'globalSearch',
    'keydown #global-search-value': 'launchGlobalSearch',
    'click #global-filter-process': 'globalFilter'
  },
  menuClick (e) {
    $('li.active-sub').removeClass('active-sub')
    $(e.currentTarget).closest('li').addClass('active-sub')
  },
  getRenderData () {
    app.initCart()
    let r = {
      now: moment().format('dddd D MMMM YYYY HH:mm:ss')
    }
    if (this.session && this.session.user) {
      r.username = this.session.user.prenom + ' ' + this.session.user.nom
      r.profil = this.session.user.profil
      if (localStorage && localStorage.getItem('cart')) {
        r.cart = JSON.parse(localStorage.getItem('cart')).products
        r.cartLength = r.cart.length ? r.cart.length : 0
      }
    }
    return r
  },
  afterRender () {
    this.rendered = true // Important pour que le routeur sache facilement que le home est déjà rendu
    // Activation des dropdown toggle
    $('.dropdown-toggle').dropdown()

    this.acSport()
    this.acPays()
    this.acDivision()

    app.initTooltip()
  },
  logout (e) {
    app.ajax({
      type: 'DELETE',
      url: '/login',
      success: function (data) {
        window.location = '/'
      }
    })
  },
  newConseil (e) {
    app.conseilView.form()
  },
  removeFromCart (e) {
    let id = $(e.currentTarget).data('id')

    if (id && localStorage && localStorage.getItem('cart')) {
      let oldCart = JSON.parse(localStorage.getItem('cart'))
      let cart = {}
      cart.products = oldCart.products.filter((obj) => obj.id_conseil !== id)

      localStorage.setItem('cart', JSON.stringify(cart))
      $('#cart').empty().html(require('views/templates/top-cart')({
        cart: cart.products,
        cartLength: cart.products.length
      })).show()
      $('.dropdown-toggle').dropdown()
    }
  },
  globalFilter (e) {
    e.preventDefault()
    app.accueilView.listConseils()
  },
  globalSearch (e) {
    e.preventDefault()
    app.accueilView.listConseils()
  },
  launchGlobalSearch (e) {
    if (e && e.keyCode === 13) this.globalSearch(e)
  },
  acSport () {
    $('#filter-sport-ui').attr('disabled', true)
    app.ajax({
      url: '/sport',
      complete: app.onComplete({
        success: (d) => {
          let data = d.map(({sport, id_sport}) => ({ id: id_sport, text: `${sport}` }))
          data.unshift({ id: '', text: '' })
          app.select2('#filter-sport-ui', { data, placeholder: '-- Choisissez un sport --' })
          $('#filter-sport-ui').attr('disabled', false)
        }
      })
    })
  },
  acPays () {
    $('#filter-pays-ui').attr('disabled', true)
    app.select2('#filter-pays-ui', {
      ajax: {
        url: '/pays',
        type: 'GET',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            'no-limit': 1
          }
        },
        processResults: function (data) {
          return {
            results: $.map(data, ({pays, id_pays}) => ({ id: id_pays, text: `${pays}` }))
          }
        }
      },
      minimumInputLength: 2,
      placeholder: '-- Choisissez un pays --'
    })
    $('#filter-pays-ui').attr('disabled', false)
  },
  acDivision () {
    $('#filter-division-ui').attr('disabled', true)
    app.ajax({
      url: '/division',
      complete: app.onComplete({
        success: (d) => {
          let data = d.map(({division, sport, pays, id_division}) => ({ id: id_division, text: `${sport} - ${division} (${pays})` }))
          data.unshift({ id: '', text: '' })
          app.select2('#filter-division-ui', { data, placeholder: '-- Choisissez une division --' })
          $('#filter-division-ui').attr('disabled', false)
        }
      })
    })
  }
})
